import api from './api';

export interface CostEstimate {
  total_documents: number;
  patent_count: number;
  other_count: number;
  skipped_count: number;
  estimated_relevant: number;
  estimated_cost_cents: number;
  currency: string;
  model_id: string;
  model_name: string | null;
}

export interface ReviewLaunchResponse {
  review_id: string;
  transcript_id: string;
  total_documents: number;
  skipped_documents: number;
}

export interface ReviewProgress {
  status: string;
  batch_label: string;
  pass1_processed: number;
  pass1_total: number;
  pass1_relevant: number;
  pass2_processed: number;
  pass2_total: number;
  current_document: string | null;
  current_phase: string | null;
  total_tokens_used: number;
  estimated_cost_cents: number;
  error_message: string | null;
}

export const fullKBReviewService = {
  async estimateCost(subProjectId: string, kbId: string): Promise<CostEstimate> {
    const res = await api.post(
      `/sub-projects/${subProjectId}/full-kb-review/estimate`,
      { kb_id: kbId }
    );
    return res.data;
  },

  async launchReview(subProjectId: string, kbId: string): Promise<ReviewLaunchResponse> {
    const res = await api.post(
      `/sub-projects/${subProjectId}/full-kb-review`,
      { kb_id: kbId }
    );
    return res.data;
  },

  async getProgress(subProjectId: string, reviewId: string): Promise<ReviewProgress> {
    const res = await api.get(
      `/sub-projects/${subProjectId}/full-kb-review/${reviewId}/progress`
    );
    return res.data;
  },

  async cancelReview(subProjectId: string, reviewId: string): Promise<void> {
    await api.post(
      `/sub-projects/${subProjectId}/full-kb-review/${reviewId}/cancel`
    );
  },
};
